import React from 'react';
//added for quality flag
import Attention from '../SVGComponents/Attention';
import CustomToolTipHost from '../CustomToolTipHost/CustomToolTipHost';
import { useTranslation } from 'react-i18next';
import '../../pages/StudyList/StudyList.css';

const QualityIcon = ({ errors, size = '18px', style = {}, combined = false }) => {
  const { t } = useTranslation();

  // Group errors to show unique messages in the tooltip
  const uniqueErrors = React.useMemo(() => {
    if (!Array.isArray(errors) || errors.length === 0) return [];

    return [...new Set(errors.map(err => {
      if (typeof err === 'string') return err;
      return err?.message || err?.text || JSON.stringify(err);
    }).filter(Boolean))].sort((a, b) => a.localeCompare(b));
  }, [errors]);

  if (uniqueErrors.length === 0) {
    return null;
  }

  const tooltipContent = (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <span
        className="studylist-triage-info-text"
        style={{ marginBottom: "4px", display: "block" }}
      >
        {t('viewer.poor_quality_image', 'Poor Quality Image')}
      </span>
      {uniqueErrors.map((msg, index) => (
        <span
          key={index}
          className="studylist-triage-finding-text"
          style={{ display: "block", width: "100%", textAlign: "left" }}
        >
          <span className="finding-text-triage-column">
            {msg}
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', ...style }}>
      <CustomToolTipHost
        content={tooltipContent}
        id="quality-alert-tooltip"
      >
        <div style={{ display: 'flex', cursor: 'pointer', padding: '2px' }}>
          <Attention />
        </div>
      </CustomToolTipHost>
    </div>
  );
};

export default QualityIcon;
